// extracted by mini-css-extract-plugin
export default {"modalTitle":"DXgcU","modal":"XFFlY","header":"xjJgl","headerCard":"x8rBe","body":"yPv4Y","bodyCol":"eigjU","bodyBlock":"lVg0M","bodyBlockTitle":"zx76A","bodyBlockItem":"qZ7bA"};